import classes from "./SelectionActionButton.module.scss";
import { ButtonHTMLAttributes } from "react";
import { className } from "utils/strings";

type SelectionActionButtonProps = {
  icon: React.ReactElement;
  text: string;
} & ButtonHTMLAttributes<HTMLButtonElement>

export const SelectionActionButton = (props: SelectionActionButtonProps) => {
  const { text, icon, ...buttonProps } = props;

  const buttonClassName = className({
    [classes.button]: true,
    [props.className ?? ""]: true,
  });

  return (
    <button {...{ ...buttonProps, className: buttonClassName }}>
      {icon}
      <span className={classes.text}>{ text }</span>
    </button>
  );
};
